import { render, staticRenderFns } from "./Photofunia.vue?vue&type=template&id=34f83164&scoped=true&"
import script from "./Photofunia.vue?vue&type=script&lang=js&"
export * from "./Photofunia.vue?vue&type=script&lang=js&"
import style0 from "./Photofunia.vue?vue&type=style&index=0&id=34f83164&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f83164",
  null
  
)

export default component.exports